/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
import { ApiConfig } from '~shared/constants/api.config';
import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '~env/environment';
import { isDevMode } from '@angular/core';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

export const IMS_ROLE = 'ROLE_BUYER';

export const HORECA_TAG_FEATURE = 'coba_horeca_tag';
export const FF_GA_PROCEED_TO_CHECKOUT_CLICK = 'FF_GA_PROCEED_TO_CHECKOUT_CLICK';
export const FF_CO_ADDRESS_EDIT_STANDARD_USER = 'ff_co_address_edit_standard_user';
export const FF_REGISTER_WITH_EMAIL_ON_TIER_ONE = 'FF_REGISTER_WITH_EMAIL_ON_TIER_ONE';
export const FF_GET_COMPANY_FROM_VAT_ID = 'FF_GET_COMPANY_FROM_VAT_ID';
export const FF_AUTH_CHECK_DELAY = 'FF_AUTH_CHECK_DELAY';
export const FF_LOGIN_MONITORING_LOGGING_STRATEGY = 'FF_LOGIN_MONITORING_LOGGING_STRATEGY';
export const FF_MAGIC_LINK_AUTH = 'FF_MAGIC_LINK_AUTH';
export const FF_ACCOUNT_FLYOUT = 'FF_ACCOUNT_FLYOUT';
export const FF_LOGIN_OR_PASSWORD_RESET = 'FF_LOGIN_OR_PASSWORD_RESET';
export const FF_GA_PASSWORDLESS_SIGNUP_BUTTON_CLICK = 'FF_GA_PASSWORDLESS_SIGNUP_BUTTON_CLICK';
export const FF_PASSWORD_LESS_SIGNUP = 'FF_SL_PASSWORDLESS_SIGNUP_TRAFFIC';
export const FF_FLYOUT_WEB_COMPONENT = 'FF_FLYOUT_WEB_COMPONENT';
export const FF_GET_COMPANY_FROM_KVK = 'FF_GET_COMPANY_FROM_KVK';
export const FF_STATIC_BLOCKED_VAT_IDS = 'FF_STATIC_BLOCKED_VAT_IDS';
export const FF_ACCOUNT_INFO_V2 = 'FF_ACCOUNT_INFO_V2';
export const FF_FORCE_DIGITAL_IDENTITY_CREATION = 'FF_FORCE_DIGITAL_IDENTITY_CREATION';
export const FF_REMOVE_REACT_COOKIE = 'FF_REMOVE_REACT_COOKIE';
export const FF_SAVE_LEGAL_ADDRESS_AS_BILLING_AND_SHIPPING = 'FF_SAVE_LEGAL_ADDRESS_AS_BILLING_AND_SHIPPING';
export const FF_SL_SERVICE_BUYER_GATEWAY_ORDER_MANAGEMENT = 'FF_SL_SERVICE_BUYER_GATEWAY_ORDER_MANAGEMENT';
export const FF_SL_SYNC_SSO_FOR_REACT_APP = 'FF_SL_SYNC_SSO_FOR_REACT_APP';
export const FF_SL_DISABLE_SILENT_LOGIN = 'FF_SL_DISABLE_SILENT_LOGIN';
export const FF_SL_ENABLE_FALLBACK_FLYOUT_FOR_HEADQUATERS = 'FF_SL_ENABLE_FALLBACK_FLYOUT_FOR_HEADQUATERS';
export const FF_SL_TIER2_BUSINESS_DETAILS_ADDRESS_AUTOCOMPLETE = 'FF_SL_TIER2_BUSINESS_DETAILS_ADDRESS_AUTOCOMPLETE';
export const FF_SL_FORCE_REDIRECTION_TO_VALIDATE_EMAIL = 'FF_SL_FORCE_REDIRECTION_TO_VALIDATE_EMAIL';
export const FF_SL_CODE_LOGIN_DISABLE_SR = 'FF_SL_CODE_LOGIN_DISABLE_SR';
export const WEB_APP_BUYER_REACT_SESSION_KEY = 'web_app_buyer_session';
export const SL_USER_LOGIN_TYPE_KEY = 'SL_USER_LOGIN_TYPE';
export const FF_SL_NG_ADDRESS_BOOK = 'FF_SL_NG_ADDRESS_BOOK';
export const FF_SL_ENABLE_PERSON_SIGNUP_V2 = 'FF_SL_ENABLE_PERSON_SIGNUP_V2';
export const FF_SL_REDIRECT_ANGULAR_SIGNUP_LOGIN_TO_REACT = 'FF_SL_REDIRECT_ANGULAR_SIGNUP_LOGIN_TO_REACT';

export const AUTHORIZATION_NOTIFICATIONS = {
  failedLogin: 'PAGES.AUTH.NOTIFICATIONS.FAILED_LOGIN',
  successRegistration: 'PAGES.AUTH.NOTIFICATIONS.SUCCESS_REGISTRATION',
  accountValidation: 'PAGES.AUTH.NOTIFICATIONS.ACCOUNT_VALIDATION',
  resendAccountValidation: 'PAGES.AUTH.NOTIFICATIONS.RESEND_ACCOUNT_VALIDATION',
  submitError: 'PAGES.AUTH.NOTIFICATIONS.SUBMIT_ERROR.',
  contextSwitchError: 'PAGES.AUTH.CONTEXT_SWITCH.ERROR',
};

export const enum AuthorizationTypeEnum {
  login = 'login',
  registerWithMetroCard = 'registerWithMetroCard',
  registerWithoutMetroCard = 'registerWithoutMetroCard',
  registerConsumer = 'registerConsumer',
  registerTierTwoAccount = 'registerTierTwoAccount',
}

export const enum SignUpTypeEnum {
  personal = 'Personal',
  business = 'Business',
}

export const enum BusinessRegistrationType {
  withCard = 'With Metro Card',
  newBusiness = 'New Business',
}

export const authorizationEndpoints = () => ({
  login: `${ApiConfig.SVC_IMS_API_URL()}/accounts/auth/login`,
  // prettier-ignore
  idamRegister:
   `${ApiConfig.SVC_METRONOM_CSS_PROXY_BASE()}/signup/api/v1/${getCountryDomainCode()}/person`,
  idamRegisterV2: `${ApiConfig.SVC_PUBLIC_BUYER_ACCOUNT_API_URL()}/signup/person`,
  tierTwoAccount: `${ApiConfig.SVC_BUYER_API_URL()}/business-account`,
  validateEmail: `${ApiConfig.SVC_BUYER_API_URL()}/validate/email`,
  getCompanyDataFromVatId: `${ApiConfig.SVC_BUYER_API_URL()}/business-account`,
  consumer: `${ApiConfig.SVC_USER_ACCOUNT_API_URL()}/public/consumers`,
  newEntrepreneur: `${ApiConfig.SVC_USER_ACCOUNT_API_URL()}/public/entrepreneurs`,
  metroCardHolder: `${ApiConfig.SVC_USER_ACCOUNT_API_URL()}/public/entrepreneurs/metro-card`,
  digitalAccount: `${ApiConfig.SVC_USER_ACCOUNT_API_URL()}/public/entrepreneurs/digital`,
});

export const authCSSEndpoints = () => ({
  tierTwoAccount:
    // prettier-ignore
    `${ApiConfig.SVC_METRONOM_CSS_PROXY_BASE()}/register/api/v1/${getCountryDomainCode()}/account`,
  // prettier-ignore
  flyoutStatus: (handle: string) =>
    `${ApiConfig.SVC_METRONOM_CSS_PROXY_BASE()}/personal/api/v1/${
      getCountryDomainCode()
     }/account-flyout-data/changes/${handle}/status`,
  // prettier-ignore
  setActiveContext:
    `${ApiConfig.SVC_METRONOM_CSS_PROXY_BASE()}/personal/api/v1/${getCountryDomainCode()}/active-context`,
});

export const createAuthConfig = (): AuthConfig => ({
  issuer: environment.IDAMSSO() && environment.IDAMSSO().issuer,
  redirectUri: `${location.origin}${location.pathname}`,
  clientId: environment.IDAMSSO() && environment.IDAMSSO().clientId,
  useSilentRefresh: true,
  silentRefreshRedirectUri: `${location.origin}${environment.baseHref() || '/'}static/assets/silent-refresh.html`,
  responseType: 'code',
  scope: 'openid',
  postLogoutRedirectUri: `${location.origin}${location.pathname}`,
  showDebugInformation: isDevMode(),
  clearHashAfterLogin: true,
  sessionChecksEnabled: true,
  tokenEndpoint: environment.IDAMSSO() && `${environment.IDAMSSO().issuer}/authorize/api/oauth2/access_token`,
});

export enum AuthorizationStateType {
  Pending = 'pending',
  LoggedIn = 'LoggedIn',
  Failed = 'fail',
  LoggedOut = 'logged-out',
}

export const taxIDConflictError = 'taxNumberNotUnique';

export const USER_TYPE = 'CUST';

export const OAUTH_ERRORS = {
  loadDiscoveryDocumentAndTryLogin: 'Error while executing loadDiscoveryDocumentAndTryLogin',
  oAuthService: 'Error while configuring oAuthService',
  initCodeFlow: 'Error while executing initCodeFlow',
};
